import { useState, useEffect } from 'react'
import MaterialTable from '@material-table/core'
import { FaRegFilePdf, FaCheck } from 'react-icons/fa'
import { makePaymentsGetRequest } from 'utils/api'
import { timezoneDate } from 'utils/helpers'
import { NumericFormat } from 'react-number-format'
import moment from 'moment'
import { getTimezone } from 'utils/authService'
import s from './Invoices.scss'

const columns = [
  { title: 'Invoice number', field: 'number' },
  {
    title: 'Start date',
    field: 'periodStart',
    render: row => timezoneDate(row.periodStart)
  },
  {
    title: 'End date',
    field: 'periodEnd',
    render: row => timezoneDate(row.periodEnd)
  },
  {
    title: 'Current invoice due amount',
    field: 'amountDue',
    render: row => (
      <NumericFormat
        thousandSeparator
        decimalScale={2}
        value={row.amountDue}
        prefix="$"
        displayType={'text'}
      />
    )
  },
  {
    title: 'Total due amount',
    field: 'amountRemaining',
    render: row => (
      <NumericFormat
        thousandSeparator
        decimalScale={2}
        value={row.amountRemaining}
        prefix="$"
        displayType={'text'}
      />
    )
  },
  {
    title: 'PDF',
    field: 'invoicePdf',
    render: rowData => (
      <a href={rowData.invoicePdf} target="_blank" rel="noopener noreferrer">
        <FaRegFilePdf />
      </a>
    )
  },
  {
    title: 'Paid',
    field: 'status',
    render: rowData => (rowData.status === 'paid' ? <FaCheck /> : '')
  }
]

const Invoices = () => {
  const [invoices, setInvoices] = useState([])
  const [usage, setUsage] = useState({
    usersMetaData: {}
  })

  useEffect(() => {
    ;(async () => {
      const invoicesResponse = await makePaymentsGetRequest(`/v1/invoices`)
      if (invoicesResponse.length) {
        setInvoices(invoicesResponse.filter(i => i.billingReason !== 'upcoming'))
        setUsage(invoicesResponse.filter(i => i.billingReason === 'upcoming')[0])
      }
    })()
  }, [])

  return (
    <div className={s.listWrapper}>
      <div className={s.usageContainer}>
        <h6>Upcoming Invoice:</h6>
        <p>
          This is a preview of the invoice that will be billed on{' '}
          {moment.tz(usage.periodEnd, getTimezone()).format('MMM DD')}. It may change if the
          subscription is updated.
        </p>
        <div className={s.invoiceTableContainer}>
          <div className={s.tableRow}>
            <span>DESCRIPTION</span>
            <span>QTY</span>
            <span className={s.sumsContainer}>UNIT PRICE</span>
            <span className={s.sumsContainer}>AMOUNT</span>
          </div>
          <div className={s.tableRow}>
            <span>
              {moment.tz(usage.periodStart, getTimezone()).format('MMM DD YYYY')} -{' '}
              {moment.tz(usage.periodEnd, getTimezone()).format('MMM DD YYYY')}
            </span>
            <span />
            <span />
            <span />
          </div>
          {usage.items?.map((item, index) => (
            <div key={index} className={s.tableRow}>
              <span>{item.description}</span>
              <span>1</span>
              <span className={s.sumsContainer}>
                <strong>${item.price}</strong>
              </span>
              <span className={s.sumsContainer}>
                <strong>${item.price}</strong>
              </span>
            </div>
          ))}
          <div className={s.tableRow}>
            <span />
            <span />
            <span className={s.sumsContainer}>
              <strong>SUBTOTAL</strong>
              <br />
              <br />
              {usage.discountAmount && usage.discountReason && (
                <>
                  <span className={s.adjustmentsContainer}>
                    {usage.discountReason} (${usage.discountAmount} off)
                  </span>
                  <br />
                  <br />
                </>
              )}
              <strong>TOTAL</strong>
              <br />
              <br />
              <strong>AMOUNT DUE</strong> <br />
              <br />
            </span>
            <span className={s.sumsContainer}>
              <strong>${usage.subtotal}</strong>
              <br />
              <br />
              {usage.discountAmount && (
                <>
                  <strong>-${usage.discountAmount}</strong>
                  <br />
                  <br />
                </>
              )}
              <strong>${usage.total}</strong>
              <br />
              <br />
              <strong>${usage.amountDue}</strong> <br />
              <br />
            </span>
          </div>
        </div>
      </div>
      <div className={s.usageContainer}>
        <h6>Current Month Usage:</h6>
        <ul>
          {Object.keys(usage.usersMetaData).map(userEmail => (
            <li key={userEmail}>
              {userEmail}: {usage.usersMetaData[userEmail]}
            </li>
          ))}
        </ul>
      </div>
      <MaterialTable
        title="Invoice History:"
        columns={columns}
        data={invoices}
        options={{
          actionsColumnIndex: -1,
          sorting: false,
          headerStyle: {
            backgroundColor: '#eee',
            color: '#000',
            position: 'sticky',
            top: 0,
            zIndex: 1
          },
          maxBodyHeight: '400px',
          pageSize: 20,
          padding: 'dense'
        }}
        style={{
          boxShadow: 'none'
        }}
      />
    </div>
  )
}

export default Invoices
